// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alatsi&family=Nunito:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Alatsi", sans-serif;
}

body {
  font-family: "Nunito", sans-serif;
}

.wrapper {
  width: 100%;
  background-size: cover;
  position: relative;
}

.mapPageWrapper {
  width: 94%;
  background-size: cover;
  position: relative;
  margin: -30px auto;
}

.mapPageWrapper > div:nth-child(2) {
  margin: 25px auto !important;
  min-width: 80% !important;
  height: 350px !important;
}

@media (min-width: 1180px) {
  .mapPageWrapper {
    width: 80%;
  }
}

.collapseSidebar {
  width: 100px !important;
}

.sidebar .nav-link {
  color: rgba(255, 255, 255, 0.5);
  font-weight: bold;
  font-size: 14px;
  padding: 1rem;
}

.sidebar .nav-link.active {
  color: #ffffff;
}

.sidebar .nav-link-column {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.sidebar .sidebar-sizer-btn {
  background-color: #7591e3;
  color: #b6c8f1;
  width: 40px;
  height: 40px;
  box-sizing: border-box;
}

.page-navbar {
  /* background-color: #4e73df; */
  background-color: #160b8b;
}

.page-navbar .navbar-brand {
  font-family: "Alatsi", sans-serif;
}

.page-navbar .nav-item .dropdown-menu {
  font-size: 14px;
  margin-top: 1rem;
  min-width: initial;
  left: initial;
  right: 0;
}

.page-navbar .nav-item .dropdown-menu .dropdown-item {
  color: #2e2f37;
}

.page-navbar .nav-item .dropdown-menu .dropdown-item i {
  color: #d1d3e2;
}

.page-navbar .nav-link {
  font-size: 14px;
  position: relative;
}

.page-navbar .nav-link .badge {
  position: absolute;
  left: 15px;
  top: 5px;
  font-size: 8px;
}

.page-navbar .nav-link img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
}

.page-content {
  width: 100%;
  min-height: 100vh;
  padding-left: 250px;
  box-sizing: border-box;
  position: relative;
  transition: padding-left 500ms;
  background: #f5f5f5;
}

.nav.nav-tabs {
  border-bottom: none;
}

.nav.nav-tabs .nav-item {
  font-size: 13px;
  color: black;
  border: none;
  border-bottom: 3px solid transparent;
}

.nav.nav-tabs .nav-item.active {
  transition: border 0.3s ease-in;
  border-bottom: 3px solid rgba(1, 57, 63, 1);
}

.collapsePageContent {
  padding-left: 80px;
}

.page-content .content {
  box-sizing: border-box;
  padding: 30px 10px;
}

.content-title {
  color: #5a5c69;
  font-size: 24px;
  margin-bottom: 1.5rem;
}

.content-card {
  border: 1px solid #e3e6f0;
  border-radius: 5px;
  overflow: hidden;
}

.content-card .content-card-header {
  background-color: #f8f9fc;
  border-bottom: 1px solid #e3e6f0;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.content-card .content-card-header .card-header-title {
  color: #4e73df;
  font-size: 16px;
  margin-bottom: 0;
}

.content-card .content-card-body {
  padding-top: 2rem;
}

.content-table thead tr th {
  color: #858796 !important;
  font-size: 13px;
  font-weight: bold;
}

.content-table tbody tr td {
  color: #858796 !important;
  font-size: 13px;
  vertical-align: middle;
}

.content-table tbody tr td .table-btn-link {
  color: #224abe;
  background-color: transparent;
  border: 0;
  outline: 0;
  font-size: 13px;
}

.content-table tbody tr td .table-btn-link:hover {
  text-decoration: underline;
}

.content-table tbody tr td .dropdown-menu {
  font-size: 12px;
}

.content-table tbody tr td .table-btn-solid {
  font-size: 13px;
  background-color: #4e73df;
  color: #ffffff;
}

.pagination {
  font-size: 12px;
  color: #224abe;
}

.pagination .page-item.active .page-link {
  background-color: #01393f;
  margin: 5px;
  border-radius: 0;
}

.pagination .page-item .page-link {
  background-color: #fff;
  margin: 5px;
  border-radius: 0;
}

.page-item:last-child .page-link {
  border-radius: 0 !important;
}

.copyright {
  margin: 0;
  font-size: 13px;
  color: #858796;
  padding-bottom: 10px;
}

.ReactModal__Overlay {
  z-index: 1000;
}

/* Dashboard (Layout) styles  */

.adminContain {
  padding-left: 20px;
  padding-right: 20px;
}

.blockPadding {
  /* background-color: #06b4c8; */
  /* padding: 10px; */
  /* margin: 10px; */
}

.threeBlock {
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: #06b4c8;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px !important;

  /* flexDirection: "column",
  justifyContent: "center",
  display: "flex", */
}
.threeBlock.blockSecond {
  background-color: #ef756d;
}
.threeBlock.blockThird {
  background-color: #ffff88;
}
.rectangleBlueLight {
  background-color: #21cde1 !important;
}
.rectangleGreen {
  background-color: #82efd2 !important;
}

.threeBlockChart {
  height: 165px;
  border: 1px solid #01393f;
  /* display: block; */
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.mainContain {
  /* margin-top: 20px; */
  justify-content: center;
}

.divider {
  /* position: absolute; */
  width: 100%;
  height: 0px;
  /* left: 95px; */
  top: 321px;
  display: block;
  border: 1px solid #c4c4c4;
  margin-top: 20px;
}

.dividerHalf {
  width: 80%;
  display: block;
  border: 1px solid #c4c4c4;
  margin-top: 10px;
  margin-bottom: 15px;
  align-self: center;
  /* margin-top: 20px; */
}

.rectangleBlue {
  width: 19px;
  height: 19px;
  background: #06b4c8;
  margin-left: 1vw;
  margin-right: 10px;
}

.rectangleYellow {
  width: 19px;
  height: 19px;
  background: #ebeb3b;
  margin-left: 1vw;
  margin-right: 10px;
}

.yellowLine {
  width: 100%;
  height: 0px;
  left: 95px;
  top: 321px;
  display: block;
  border: 3px solid #ffff88;
  margin-top: 10px;
}

.blueLine {
  width: 100%;
  height: 0px;
  left: 95px;
  top: 321px;
  display: block;
  border: 3px solid #06b4c8;
  margin-top: 10px;
}

.rectanglePeach {
  width: 19px;
  height: 19px;
  background: #ff8383;
  margin-left: 1vw;
  margin-right: 10px;
}

.peachLine {
  width: 100%;
  height: 0px;
  left: 95px;
  top: 321px;
  display: block;
  border: 3px solid #ff8383;
  margin-top: 10px;
}

.headerText {
  /* position: absolute; */
  /* left: 57px;
  top: 17px; */
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  color: #000;
}

.textDivider {
  width: 80%;
  display: block;
  border: 1px solid #c4c4c4;
  margin-top: 20px;
}

.boxValue {
  /* font-family: Red Hat Display; */
  font-weight: 800;
  font-size: 40px;
  line-height: 53px;
  color: #000;
  text-align: left;
  padding-left: 15px;
}

.displayFlex {
  display: flex;
}

.uploadButton {
  /* position: absolute; */
  width: 100px;
  height: 30px;
  left: 146px;
  top: 79px;

  background: #42db89;

  font-family: Red Hat Display;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 19px;
  border-radius: 5px;
  /* identical to box height */

  color: #ffffff;

  /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */
}

.dropText {
  font-family: Red Hat Display;
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 20px;
  /* identical to box height */

  color: #000000;
}
.dropOrText {
  font-family: Red Hat Display;
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 20px;
  /* identical to box height */
  margin-top: 20px;
  margin-bottom: 20px;
  color: #000000;
}

/*# sourceMappingURL=style.css.map */

.woList {
  background-color: #fff;
  background-size: 100%;
  max-height: 420px;
  overflow-y: scroll;
}

.woList1 {
  background-color: #fff;
  background-size: 100%;
  border-right: 0.5px solid #000000;
  max-height: 420px;
  overflow-y: scroll;
}

.woListContainer {
  padding-top: 15px;
}

.chartCard canvas {
  height: calc(100% - 50px) !important;
  width: 100% !important;
}

body > iframe {
  display: none !important;
}

.chartCol {
  background-size: 100%;
  align-items: center;
}

.spinner-box {
  margin: 0 auto;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

.circle-border {
  width: 25px;
  height: 25px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: white;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.1) 33%, white 100%);
  animation: spin 0.8s linear 0s infinite;
}

.circle-core {
  width: 100%;
  height: 100%;
  background-color: #42db89;
  border-radius: 50%;
}

.chartCol .card-block {
  font-size: 14px;
  padding: 0 !important;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 15px 20px !important;
}
.chartCol .card-block-head {
  padding: 0 0 15px;
  border-bottom: 1px solid #ccc;
}

.chartCol .cardBody {
  /* padding: 20px 0 8px; */
  /* display: flex;
  flex-direction: column;
  gap: 20px; */
}
.cardBody-list {
  padding: 20px 0 !important;
  border-bottom: 1px solid #eee !important;
  display: block;
}
.cardBody-list:last-child {
  border-bottom: none !important;
}
.chartCol .card-block-head h4 {
  font-size: 22px;
  line-height: normal;
  margin: 0;
  height: auto;
}
.chartCol .card-block-head a {
  padding: 0 !important;
  margin: 0 !important;
}
.chartCol .card-block img {
  width: 40px;
  height: 40px;
}
.chartCol .card-block span {
  display: block;
  font-size: 13px;
  color: #aaa;
}
.chartCol .card-block a {
  color: #000;
  font-weight: 500;
  margin-bottom: 6px;
  border-bottom: 1px solid #ccc;
  padding: 10px;
}
.chartCol .card-block a:last-child {
  border-bottom: 0;
}
.chartCol .card-block a:hover {
  text-decoration: none;
}
.constructionImg {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  border: 2px solid #000;
}
.constructionImg canvas {
  width: 25px !important;
  height: 25px !important;
}
.mapCol {
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 15px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  height: 750px;
}
.mapCol > div {
  width: 100% !important;
}

.pageTemplate {
  min-height: calc(100vh - 79px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modal-dialog .modal-header svg {
  cursor: pointer;
}

.deviation-modal-header {
  padding: 1rem 1rem;
  padding-bottom: 0;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  text-align: center;
}

.deviationForm {
  display: table-cell !important;
  width: 33.3%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  align-content: center;
}
.form-text {
  text-align: center;
}
.deviationForm.form-check {
  text-align: center;
  border-bottom: none;
}

.deviationForm input[type="checkbox"] {
  text-align: center;
  border: 1.5px solid;
}
.deviationForm input[type="checkbox"] + label {
  font-weight: 500;
}
.deviationForm input[type="checkbox"]:checked + label {
  color: #00b353;
}

.markerBtn:hover {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/Dashboard.css"],"names":[],"mappings":"AAEA;;;;;;EAME,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA,+BAA+B;;AAE/B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EACzB,gDAAgD;EAChD,6BAA6B;;EAE7B;;oBAEkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB;cACY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,SAAS;;EAET,mBAAmB;;EAEnB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;;EAE5B,cAAc;;EAEd,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;EAE5B,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oCAAoC;;AAEpC;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,2EAA2E;EAC3E,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gDAAgD;EAChD,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB;;cAEY;AACd;AACA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,sCAAsC;EACtC,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Alatsi&family=Nunito:wght@400;700&display=swap\");\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Alatsi\", sans-serif;\n}\n\nbody {\n  font-family: \"Nunito\", sans-serif;\n}\n\n.wrapper {\n  width: 100%;\n  background-size: cover;\n  position: relative;\n}\n\n.mapPageWrapper {\n  width: 94%;\n  background-size: cover;\n  position: relative;\n  margin: -30px auto;\n}\n\n.mapPageWrapper > div:nth-child(2) {\n  margin: 25px auto !important;\n  min-width: 80% !important;\n  height: 350px !important;\n}\n\n@media (min-width: 1180px) {\n  .mapPageWrapper {\n    width: 80%;\n  }\n}\n\n.collapseSidebar {\n  width: 100px !important;\n}\n\n.sidebar .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n  font-weight: bold;\n  font-size: 14px;\n  padding: 1rem;\n}\n\n.sidebar .nav-link.active {\n  color: #ffffff;\n}\n\n.sidebar .nav-link-column {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n.sidebar .sidebar-sizer-btn {\n  background-color: #7591e3;\n  color: #b6c8f1;\n  width: 40px;\n  height: 40px;\n  box-sizing: border-box;\n}\n\n.page-navbar {\n  /* background-color: #4e73df; */\n  background-color: #160b8b;\n}\n\n.page-navbar .navbar-brand {\n  font-family: \"Alatsi\", sans-serif;\n}\n\n.page-navbar .nav-item .dropdown-menu {\n  font-size: 14px;\n  margin-top: 1rem;\n  min-width: initial;\n  left: initial;\n  right: 0;\n}\n\n.page-navbar .nav-item .dropdown-menu .dropdown-item {\n  color: #2e2f37;\n}\n\n.page-navbar .nav-item .dropdown-menu .dropdown-item i {\n  color: #d1d3e2;\n}\n\n.page-navbar .nav-link {\n  font-size: 14px;\n  position: relative;\n}\n\n.page-navbar .nav-link .badge {\n  position: absolute;\n  left: 15px;\n  top: 5px;\n  font-size: 8px;\n}\n\n.page-navbar .nav-link img {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n}\n\n.page-content {\n  width: 100%;\n  min-height: 100vh;\n  padding-left: 250px;\n  box-sizing: border-box;\n  position: relative;\n  transition: padding-left 500ms;\n  background: #f5f5f5;\n}\n\n.nav.nav-tabs {\n  border-bottom: none;\n}\n\n.nav.nav-tabs .nav-item {\n  font-size: 13px;\n  color: black;\n  border: none;\n  border-bottom: 3px solid transparent;\n}\n\n.nav.nav-tabs .nav-item.active {\n  transition: border 0.3s ease-in;\n  border-bottom: 3px solid rgba(1, 57, 63, 1);\n}\n\n.collapsePageContent {\n  padding-left: 80px;\n}\n\n.page-content .content {\n  box-sizing: border-box;\n  padding: 30px 10px;\n}\n\n.content-title {\n  color: #5a5c69;\n  font-size: 24px;\n  margin-bottom: 1.5rem;\n}\n\n.content-card {\n  border: 1px solid #e3e6f0;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.content-card .content-card-header {\n  background-color: #f8f9fc;\n  border-bottom: 1px solid #e3e6f0;\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.content-card .content-card-header .card-header-title {\n  color: #4e73df;\n  font-size: 16px;\n  margin-bottom: 0;\n}\n\n.content-card .content-card-body {\n  padding-top: 2rem;\n}\n\n.content-table thead tr th {\n  color: #858796 !important;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.content-table tbody tr td {\n  color: #858796 !important;\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.content-table tbody tr td .table-btn-link {\n  color: #224abe;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  font-size: 13px;\n}\n\n.content-table tbody tr td .table-btn-link:hover {\n  text-decoration: underline;\n}\n\n.content-table tbody tr td .dropdown-menu {\n  font-size: 12px;\n}\n\n.content-table tbody tr td .table-btn-solid {\n  font-size: 13px;\n  background-color: #4e73df;\n  color: #ffffff;\n}\n\n.pagination {\n  font-size: 12px;\n  color: #224abe;\n}\n\n.pagination .page-item.active .page-link {\n  background-color: #01393f;\n  margin: 5px;\n  border-radius: 0;\n}\n\n.pagination .page-item .page-link {\n  background-color: #fff;\n  margin: 5px;\n  border-radius: 0;\n}\n\n.page-item:last-child .page-link {\n  border-radius: 0 !important;\n}\n\n.copyright {\n  margin: 0;\n  font-size: 13px;\n  color: #858796;\n  padding-bottom: 10px;\n}\n\n.ReactModal__Overlay {\n  z-index: 1000;\n}\n\n/* Dashboard (Layout) styles  */\n\n.adminContain {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.blockPadding {\n  /* background-color: #06b4c8; */\n  /* padding: 10px; */\n  /* margin: 10px; */\n}\n\n.threeBlock {\n  height: 150px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  background-color: #06b4c8;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);\n  border-radius: 6px !important;\n\n  /* flexDirection: \"column\",\n  justifyContent: \"center\",\n  display: \"flex\", */\n}\n.threeBlock.blockSecond {\n  background-color: #ef756d;\n}\n.threeBlock.blockThird {\n  background-color: #ffff88;\n}\n.rectangleBlueLight {\n  background-color: #21cde1 !important;\n}\n.rectangleGreen {\n  background-color: #82efd2 !important;\n}\n\n.threeBlockChart {\n  height: 165px;\n  border: 1px solid #01393f;\n  /* display: block; */\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.mainContain {\n  /* margin-top: 20px; */\n  justify-content: center;\n}\n\n.divider {\n  /* position: absolute; */\n  width: 100%;\n  height: 0px;\n  /* left: 95px; */\n  top: 321px;\n  display: block;\n  border: 1px solid #c4c4c4;\n  margin-top: 20px;\n}\n\n.dividerHalf {\n  width: 80%;\n  display: block;\n  border: 1px solid #c4c4c4;\n  margin-top: 10px;\n  margin-bottom: 15px;\n  align-self: center;\n  /* margin-top: 20px; */\n}\n\n.rectangleBlue {\n  width: 19px;\n  height: 19px;\n  background: #06b4c8;\n  margin-left: 1vw;\n  margin-right: 10px;\n}\n\n.rectangleYellow {\n  width: 19px;\n  height: 19px;\n  background: #ebeb3b;\n  margin-left: 1vw;\n  margin-right: 10px;\n}\n\n.yellowLine {\n  width: 100%;\n  height: 0px;\n  left: 95px;\n  top: 321px;\n  display: block;\n  border: 3px solid #ffff88;\n  margin-top: 10px;\n}\n\n.blueLine {\n  width: 100%;\n  height: 0px;\n  left: 95px;\n  top: 321px;\n  display: block;\n  border: 3px solid #06b4c8;\n  margin-top: 10px;\n}\n\n.rectanglePeach {\n  width: 19px;\n  height: 19px;\n  background: #ff8383;\n  margin-left: 1vw;\n  margin-right: 10px;\n}\n\n.peachLine {\n  width: 100%;\n  height: 0px;\n  left: 95px;\n  top: 321px;\n  display: block;\n  border: 3px solid #ff8383;\n  margin-top: 10px;\n}\n\n.headerText {\n  /* position: absolute; */\n  /* left: 57px;\n  top: 17px; */\n  font-style: normal;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  color: #000;\n}\n\n.textDivider {\n  width: 80%;\n  display: block;\n  border: 1px solid #c4c4c4;\n  margin-top: 20px;\n}\n\n.boxValue {\n  /* font-family: Red Hat Display; */\n  font-weight: 800;\n  font-size: 40px;\n  line-height: 53px;\n  color: #000;\n  text-align: left;\n  padding-left: 15px;\n}\n\n.displayFlex {\n  display: flex;\n}\n\n.uploadButton {\n  /* position: absolute; */\n  width: 100px;\n  height: 30px;\n  left: 146px;\n  top: 79px;\n\n  background: #42db89;\n\n  font-family: Red Hat Display;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 19px;\n  border-radius: 5px;\n  /* identical to box height */\n\n  color: #ffffff;\n\n  /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */\n}\n\n.dropText {\n  font-family: Red Hat Display;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 30px;\n  line-height: 20px;\n  /* identical to box height */\n\n  color: #000000;\n}\n.dropOrText {\n  font-family: Red Hat Display;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 30px;\n  line-height: 20px;\n  /* identical to box height */\n  margin-top: 20px;\n  margin-bottom: 20px;\n  color: #000000;\n}\n\n/*# sourceMappingURL=style.css.map */\n\n.woList {\n  background-color: #fff;\n  background-size: 100%;\n  max-height: 420px;\n  overflow-y: scroll;\n}\n\n.woList1 {\n  background-color: #fff;\n  background-size: 100%;\n  border-right: 0.5px solid #000000;\n  max-height: 420px;\n  overflow-y: scroll;\n}\n\n.woListContainer {\n  padding-top: 15px;\n}\n\n.chartCard canvas {\n  height: calc(100% - 50px) !important;\n  width: 100% !important;\n}\n\nbody > iframe {\n  display: none !important;\n}\n\n.chartCol {\n  background-size: 100%;\n  align-items: center;\n}\n\n.spinner-box {\n  margin: 0 auto;\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n}\n\n.circle-border {\n  width: 25px;\n  height: 25px;\n  padding: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background: white;\n  background: linear-gradient(0deg, rgba(255, 255, 255, 0.1) 33%, white 100%);\n  animation: spin 0.8s linear 0s infinite;\n}\n\n.circle-core {\n  width: 100%;\n  height: 100%;\n  background-color: #42db89;\n  border-radius: 50%;\n}\n\n.chartCol .card-block {\n  font-size: 14px;\n  padding: 0 !important;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);\n  border-radius: 6px;\n  padding: 15px 20px !important;\n}\n.chartCol .card-block-head {\n  padding: 0 0 15px;\n  border-bottom: 1px solid #ccc;\n}\n\n.chartCol .cardBody {\n  /* padding: 20px 0 8px; */\n  /* display: flex;\n  flex-direction: column;\n  gap: 20px; */\n}\n.cardBody-list {\n  padding: 20px 0 !important;\n  border-bottom: 1px solid #eee !important;\n  display: block;\n}\n.cardBody-list:last-child {\n  border-bottom: none !important;\n}\n.chartCol .card-block-head h4 {\n  font-size: 22px;\n  line-height: normal;\n  margin: 0;\n  height: auto;\n}\n.chartCol .card-block-head a {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.chartCol .card-block img {\n  width: 40px;\n  height: 40px;\n}\n.chartCol .card-block span {\n  display: block;\n  font-size: 13px;\n  color: #aaa;\n}\n.chartCol .card-block a {\n  color: #000;\n  font-weight: 500;\n  margin-bottom: 6px;\n  border-bottom: 1px solid #ccc;\n  padding: 10px;\n}\n.chartCol .card-block a:last-child {\n  border-bottom: 0;\n}\n.chartCol .card-block a:hover {\n  text-decoration: none;\n}\n.constructionImg {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  width: 40px;\n  border-radius: 5px;\n  border: 2px solid #000;\n}\n.constructionImg canvas {\n  width: 25px !important;\n  height: 25px !important;\n}\n.mapCol {\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  padding: 15px;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);\n  border-radius: 6px;\n  height: 750px;\n}\n.mapCol > div {\n  width: 100% !important;\n}\n\n.pageTemplate {\n  min-height: calc(100vh - 79px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modal-dialog .modal-header svg {\n  cursor: pointer;\n}\n\n.deviation-modal-header {\n  padding: 1rem 1rem;\n  padding-bottom: 0;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n  text-align: center;\n}\n\n.deviationForm {\n  display: table-cell !important;\n  width: 33.3%;\n  padding: 10px;\n  border-bottom: 1px solid #ccc;\n  align-content: center;\n}\n.form-text {\n  text-align: center;\n}\n.deviationForm.form-check {\n  text-align: center;\n  border-bottom: none;\n}\n\n.deviationForm input[type=\"checkbox\"] {\n  text-align: center;\n  border: 1.5px solid;\n}\n.deviationForm input[type=\"checkbox\"] + label {\n  font-weight: 500;\n}\n.deviationForm input[type=\"checkbox\"]:checked + label {\n  color: #00b353;\n}\n\n.markerBtn:hover {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
